import joinClasses from "helpers/joinClasses";
import Button from ".";

export function PrimaryButton({ className, children, onClick, ...props }) {
  return (
    <Button
      className={joinClasses("bg-third text-white uppercase text-[14px]", className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
}
